import {Component, OnInit} from '@angular/core';
import {UserService} from "../user.service";
import {LayoutService} from "../../layout/layout.service";

@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user:any;

  constructor(
    private userService: UserService,
              private layoutService: LayoutService) {
  }

  ngOnInit() {
    // this.userService.getLoginInfo().subscribe(user => {
    //   this.user = user
    // })
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.user = currentUser;
    this.user.username = currentUser.userSystem.fullName;
    this.user.picture = "assets/img/avatars/sunny.png";
    this.user.picture = "/CBAZALAR4/sunny.png";
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/login-info/login-info.component.ts